import AxiosClient from "../AxiosClient";

export const getProduct = (params) => {
  const url = "/api/product/searchInfoList";
  return AxiosClient.post(url, params);
};

export const getMaxProductId = (params) => {
  const url = "/api/product/searchMaxId";
  return AxiosClient.post(url, params);
};

export const getProductById = (productId) => {
  const url = "/api/product/searchInfoList";
  const params = { productId };
  return AxiosClient.post(url, params);
};

export const addProduct = (params) => {
  const url = "/api/product/insertInfo";
  return AxiosClient.post(url, params);
};

export const updateProduct = (params) => {
  const url = "/api/product/updateInfo";
  return AxiosClient.post(url, params);
};

// 商品を削除
export const deleteProduct = (params) => {
  const url = "/api/product/deleteInfo";
  return AxiosClient.post(url, params);
};
export const downloadProductPrintInfo = (requestBody = {}) => {
  const url = `/api/product/printInfoList`;
  return AxiosClient.post(url, requestBody, {
    responseType: "arraybuffer",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then(response => {
      return response;
    })
    .catch(error => {
      console.error("Error:", error);
    });
};
